{"darkMode":true,"languageFolder":"/","languageSelector":false}